import { render, staticRenderFns } from "./ProductGalery.vue?vue&type=template&id=172442e0&"
import script from "./ProductGalery.vue?vue&type=script&lang=js&"
export * from "./ProductGalery.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports